<template>
  <div class="page-kln-categories">
    <c-left-side-bar :step="3" />
    <n-loader :loading="$var('load')" />
    <div class="mid-container">
      <div class="mid-side">
        <c-mid-head v-if="!isSecondStep" back-route="kln-user-select" type="timer" h1="Категории" h2="Категории КЛН" />
        <h1>Категории{{ title }}</h1>
        <ul class="categories-list">
          <li v-for="item in categories" :key="item.id" class="category-row">
            <label>
              <input v-model="category" type="radio" :value="item">
              {{ item.title }}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="new-right-side right-container">
      <div class="right-side">
        <div :key="isSecondStep" class="btn-container" :class="{'second-step': isSecondStep}">
<!--          <n-button v-if="!isSecondStep" class="btn" :disabled="btnNextDisable" @click="getSubCategories">Далее</n-button>-->
<!--          <n-button class="btn prev" @click="getCategories">Назад</n-button>-->
          <n-button class="btn start" :disabled="btnNextDisable" @click="start">Начать</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'PageTimerCategories',
  props: {},
  data() {
    return {
      categories: [],
      title: '',
      category: [],
      btnNextDisable: true,
      isSecondStep: false,
    }
  },
  computed: {
    resultData() {
      return { userId: this.$route.query.userId, resultType: this.$route.query.resultType, access: this.$route.query.access, }
    },
  },
  watch: {
    category() {
      this.btnNextDisable = false
    },
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      this.title = ''
      this.$var('load', true)
      this.isSecondStep = false

      let types = 'KLN,OUS,OUU'

      // if (this.resultData.access?.length > 0 && this.resultData.access === 'instructor') {
      //   types = 'KLN,OUS,OUU'
      // } else {
      //   if (this.resultData.access?.length > 0) {
      //     types = 'OUS,OUU'
      //   }
      // }


      $api.timercategories.get().filter({ type: 'in:'+types, }).then((response) => {
        this.categories = response.data.content
      }).finally(() => {
        this.btnNextDisable = true
        this.$var('load', false)
      })
    },
    start() {
      this.$var('load', true)
      $api.timerresults.begin({ userId: this.resultData.userId,
        categoryId: this.category.id,
        resultType: this.resultData.resultType, 
      }).then((response) => {
        this.$router.push({ name: 'kln-timer-quizzes', query: { categoryId: this.category.id,
          resultId: response.data.content.id,
        }, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-kln-categories {
  display: flex;
  height: 100vh;
  .mid-container {
    padding: 40px 20px 0 20px;
    width: 100%;
    flex: 3;

    .mid-side {
      max-height: 100%;
      overflow: auto;
      h1 {
        margin: 10px 0 30px 0;
        padding: 0;
        font-size: 32px;
        font-weight: bold;
        color: #292929;
      }

      .categories-list {
        list-style: none;
        margin: 0;
        padding: 0;

        .category-row {
          position: relative;

          label{
            display: flex;
            align-items: center;
            margin-bottom: 28px;
          }

          input {
            width: 20px;
            height: 20px;
            margin-right: 14px;
          }

          p {
            margin: 0;
            padding: 0;
            font-size: 17px;
            color: #292929
          }

          &::before {
            content: '';
            position: absolute;
            width: 90%;
            height: 1px;
            background-color: #E9E9EC;
            right: 20px;
            bottom: -9px;
          }
        }
      }
    }
  }

  .right-container {
    flex: 2;
    .right-side {
      display: flex;
      width: 100%;

      .btn-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        width: 100%;

        &.second-step {
          justify-content: space-between;
        }

        .btn {
          font-size: .9em;
          background-color: #264F36;
          color: #ffffff;
          max-width: 390px;
          width: 100%;
          font-weight: bold;
          border-radius: 8px;

          &::v-deep .n-button:hover {
            background-color: #3C7853;
          }

          &::v-deep .n-button:active {
            background-color: #0F4122;
          }

          &.prev {
            background-color: #F2F3F7;
            color: #DB0007;
            max-width: 190px;

            &::v-deep .n-button:hover {
              background-color: #F2F3F7;
            }

            &::v-deep .n-button:active {
              background-color: #F2F3F7;
            }
          }

          &.start {
            left: 50%;
            background-color: #F2F3F7;
            color: #292929;
            max-width: 190px;

            &::v-deep .n-button:hover {
              background-color: #F2F3F7;
            }

            &::v-deep .n-button:active {
              background-color: #F2F3F7;
            }
          }
        }
      }
    }
  }
}
</style>
